import { HTTPMethod } from '../../types/enums';
import BaseAdapter from './baseAdapter';
import { AdapterInterface } from '../../types/global';

export default class PostApproveCampaign extends BaseAdapter<null> implements AdapterInterface {
  rawResponse: null;

  request: string;

  async adaptResponse(request: string): Promise<null> {
    await this.fetchApiResponse(`/api/approve-campaign?mailing_guid=${request}`, HTTPMethod.Post, { });
    return this.rawResponse;
  }
}
